export default __webpack_public_path__ + "static/media/baner3.04cad2df.png";